import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon, ClockIcon, UsersIcon, HelpCircleIcon, XCircleIcon } from 'lucide-react';
const PainCard = ({
  icon: Icon,
  title,
  delay
}: {
  icon: any;
  title: string;
  delay: number;
}) => <motion.div initial={{
  opacity: 0,
  y: 20
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true
}} transition={{
  duration: 0.5,
  delay
}} className="bg-zinc-900/80 border border-zinc-800 p-6 rounded-lg flex items-start gap-4 hover:border-red-500/30 transition-colors" data-id="element-115">
    <div className="p-2 bg-red-500/10 rounded-md text-red-500 shrink-0" data-id="element-116">
      <Icon className="w-6 h-6" data-id="element-117" />
    </div>
    <p className="text-zinc-200 font-medium text-lg" data-id="element-118">{title}</p>
  </motion.div>;
const MistakeItem = ({
  text,
  delay
}: {
  text: string;
  delay: number;
}) => <motion.li initial={{
  opacity: 0,
  x: -20
}} whileInView={{
  opacity: 1,
  x: 0
}} viewport={{
  once: true
}} transition={{
  duration: 0.4,
  delay
}} className="flex items-start gap-3 text-zinc-400" data-id="element-119">
    <XCircleIcon className="w-5 h-5 text-red-500 mt-1 shrink-0" data-id="element-120" />
    <span className="text-lg" data-id="element-121">{text}</span>
  </motion.li>;
export function PainSection() {
  return <section className="py-14 px-4 bg-[#0f0f0f] relative overflow-hidden" style={{
    paddingTop: "5px",
    paddingBottom: "5px"
  }} data-id="element-122">
      <div className="max-w-5xl mx-auto" data-id="element-123">
        <div className="text-center mb-10" data-id="element-124">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-125">
            Tu cerebro bajo presión <br data-id="element-126" />
            <span className="text-red-500" data-id="element-127">no es detective. Es presa.</span>
          </motion.h2>
          <p className="text-zinc-400 text-lg max-w-2xl mx-auto" data-id="element-128">
            Cuando estás buscando alquiler, no estás pensando con claridad.
            Estás pensando en resolver.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-5 mb-12" data-id="element-129">
          <PainCard icon={ClockIcon} title="Querés mudarte ya. Tenés tiempos límite y gente opinando." delay={0.1} data-id="element-130" />
          <PainCard icon={HelpCircleIcon} title="Tenés miedo de perder «la oportunidad» única." delay={0.2} data-id="element-131" />
          <PainCard icon={AlertTriangleIcon} title="Y ahí aparece el mensaje: «Transferí y te la reservo»." delay={0.3} data-id="element-132" />
        </div>

        <div className="bg-zinc-900 border border-zinc-800 rounded-2xl p-6 md:p-10 max-w-3xl mx-auto" data-id="element-133">
          <h3 className="text-2xl font-bold text-white mb-6 border-b border-zinc-800 pb-4" data-id="element-134">
            Lo que la mayoría hace (y por eso cae):
          </h3>
          <ul className="space-y-4" data-id="element-135">
            <MistakeItem text="Busca tips en TikTok y se queda con 2 ideas sueltas." delay={0.1} data-id="element-136" />
            <MistakeItem text="Le pregunta a un amigo y recibe 3 versiones distintas." delay={0.2} data-id="element-137" />
            <MistakeItem text="Decide por sensación: «parece serio»." delay={0.3} data-id="element-138" />
            <MistakeItem text="Se convence de que «una seña no es tanto»." delay={0.4} data-id="element-139" />
            <motion.li initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.6
          }} className="text-red-500 font-bold text-xl pt-2 pl-8" data-id="element-140">
              Hasta que lo es.
            </motion.li>
          </ul>
        </div>
      </div>
    </section>;
}